import axios from '../../customAxios'
import helpers from './../../helpers'

export default {
    getArticles({commit}, page = 1) {

        axios.get(process.env.VUE_APP_API_URL + `/article?page=${page}`)
            .then(response => (commit('storeArticles', response.data)))
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    getArticleById({commit}, articleId) {

        axios.get(process.env.VUE_APP_API_URL + `/article/${articleId}`)
            .then(response => (commit('storeArticle', response.data)))
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    storeArticle({commit}, article) {

        axios.put(process.env.VUE_APP_API_URL + `/article/${article.id}`, article)
            .then(() => {
                helpers.handleSuccessMessage("Der Artikel wurde gespeichert.", "Gespeichert")
            })

        commit('none')
    },
    createArticle({commit}, article) {


        axios.post(process.env.VUE_APP_API_URL + `/article`, article)
            .then(response => {
                helpers.handleSuccessMessage("Der Artikel wurde erstellt.", "Erstellt")
                window.location = '/Artikel/' + response.data.data.id
            }).catch(exception => {
            helpers.handleMildAxiosError(exception)
        })
        commit('resetNewArticle')
    },
    deleteArticle({commit}, article) {


        axios.delete(process.env.VUE_APP_API_URL + `/article/${article.id}`)
            .then(() => {
                helpers.handleSuccessMessage("Der Artikel wurde gelöscht.", "Erstellt")
                window.location = '/Artikel/'
                commit('clearExcuses');
            })
            .catch(() => {
                helpers.handleMildAxiosError("Der Artikel konnte nicht gelöscht werden.")
            })
    },
    deleteImage({commit}, image) {
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.delete(image.url)
        commit('none')
    },
}
